import React from 'react'
import { useSelector } from 'react-redux'
import { MULTIPATH_MODE_CAR } from '../../../store/itinerary/itinerary.constants'
import { selectCurrentMode, selectFirstCarPoolRoute } from '../../../store/itinerary/itinerary.selectors'
import carpooling from './carpooling.svg'
import { withFrenchSite } from '../../i18n/i18nSite'
import { withOnlyPE } from '../../Device'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../../genericComponents/buttons/RectangleActionButton'
import { navigateToItineraryRoute } from '../../../store/itinerary/itinerary.actions'
import { useAction } from '../../utils/react-redux'
import s from './CarpoolIncentive.less'
import { ROUTE_CARPOOL_INCENTIVE } from '../../analytics/ClickTagsService'

const CarpoolIncentive = () => {
  const currentMode = useSelector(selectCurrentMode)
  const firstCarPoolRoute = useSelector(selectFirstCarPoolRoute)
  const execNavigateToRoute = useAction(navigateToItineraryRoute)

  const openCarPoolMode = () => {
    const { routeId, provider } = firstCarPoolRoute
    execNavigateToRoute(
      { routeId, provider: provider.id },
      {
        tagInfo: { [ROUTE_CARPOOL_INCENTIVE]: 'true' }
      }
    )
  }

  if (currentMode !== MULTIPATH_MODE_CAR || !firstCarPoolRoute) return <></>

  return (
    <div className={s.outer}>
      <div className={s.container}>
        <img src={carpooling} className={s.img} width={40} height={40} alt="" />
        <div>
          <p className={s.text}>Avez-vous pensé au covoiturage ?</p>
          <RectangleActionButton
            color={COLOR_GREY_EMPTY}
            className={s.button}
            onClick={openCarPoolMode}
            deferClick
            label={'Voir les propositions'}
            size={SIZE_MEDIUM}
          />
        </div>
      </div>
    </div>
  )
}

export default withOnlyPE(withFrenchSite(CarpoolIncentive))
